import {
  useGetTeamMessagesQuery,
  useGetTeamRequestsQuery,
} from 'features/TeamChat/api/teamChat.api'

// Keeps chat and active requests loaded from page load, so the panel opens on ready data.
export const useTeamPrefetch = (enabled: boolean): void => {
  useGetTeamMessagesQuery(undefined, { skip: !enabled })
  useGetTeamRequestsQuery('active', { skip: !enabled })
}
